module.exports = __webpack_public_path__ + "static/add_to_cart-05a855f5879946ebf5364444adcebba6.svg";